const PRONUNCIATION_COMPARE_URL =
  import.meta.env.VITE_PRONUNCIATION_COMPARE_URL || '/api/pronunciation/compare';

/**
 * Score a student recording against expected text via OpenPronounce (server proxy).
 * Guests can pass audioBase64 + mimeType instead of audioUrl (no storage upload).
 * @param {{ audioUrl?: string, audioBase64?: string, mimeType?: string, expectedText: string, lang?: string, passScore?: number }} opts
 */
export async function scorePronunciationCompare({
  audioUrl,
  audioBase64,
  mimeType,
  expectedText,
  lang = 'en',
  passScore,
}) {
  const payload = {
    expectedText,
    lang,
  };
  if (audioBase64) {
    payload.audioBase64 = audioBase64;
    if (mimeType) payload.mimeType = mimeType;
  } else if (audioUrl) {
    payload.audioUrl = audioUrl;
  }
  if (passScore != null && Number.isFinite(Number(passScore))) {
    payload.passScore = Number(passScore);
  }

  const res = await fetch(PRONUNCIATION_COMPARE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const text = await res.text();
  let data = {};
  try {
    data = text ? JSON.parse(text) : {};
  } catch {
    throw new Error(res.ok ? 'Invalid pronunciation response' : `Pronunciation check failed (${res.status})`);
  }
  if (!res.ok) throw new Error(data.error || `Pronunciation check failed (${res.status})`);
  return data;
}
